import { JobStateEvent } from '@treadinc/horizon-api-spec';

import { AnalyticsController } from '~hooks/useAnalytics/AnalyticsController';

type JobAssignmentCancelAction = JobStateEvent.CANCEL | JobStateEvent.UNASSIGN;

interface JobAssignmentCancelled {
  action: JobAssignmentCancelAction;
  jobIds: string[];
  source:
    | 'actions_menu'
    | 'approvals_status_menu'
    | 'assignee'
    | 'bulk_actions'
    | 'scheduler_card'
    | 'scheduler_drag'
    | 'status_menu';
}

export function isJobAssignmentCancelAction(
  jobEvent: JobStateEvent,
): jobEvent is JobAssignmentCancelAction {
  return jobEvent === JobStateEvent.CANCEL || jobEvent === JobStateEvent.UNASSIGN;
}

export function trackJobAssignmentCancelled({
  action,
  jobIds,
  source,
}: JobAssignmentCancelled) {
  AnalyticsController.track('job_assignment_cancelled', {
    action,
    job_count: jobIds.length,
    job_ids: jobIds,
    source,
  });
}
